import Vue from 'vue'

import providerTransformer from './../../transformers/provider/'

export default (payload) => {
  const data = providerTransformer.send(payload)
  return Vue.$http.put(`catalogs/providers/${payload.providerData.number}/`, data)
}


// WEBPACK FOOTER //
// ./src/services/provider/updateProvider.js